<div class="button-wrapper" tappable (click)="clicked.emit()">
  <ng-content></ng-content>
</div>
